import image1 from "../../../../images/tours/italy/como/pexels-aul-haque-391107949-14743851.jpg";
import image2 from "../../../../images/tours/italy/como/boat.jpg";
import image3 from "../../../../images/tours/italy/como/pexels-dana-tentis-118658-726000.jpg";
import image4 from "../../../../images/tours/italy/como/pexels-francesco-ungaro-215516.jpg";
import image5 from "../../../../images/tours/italy/como/Bellagio.jpg";
import image6 from "../../../../images/tours/italy/como/Varenna.jpeg";
import React from "react";
import ImagesSection from "../../common/ImagesSection";

const ItalyComoImagesSection = () => {

    const imageList = [
        {imageUrl: image1, text: 'italy_como_img1'},
        {imageUrl: image2, text: 'italy_como_img2'},
        {imageUrl: image3, text: 'italy_como_img3'},
        {imageUrl: image4, text: 'italy_como_img4'},
        {imageUrl: image5, text: 'italy_como_img5'},
        {imageUrl: image6, text: 'italy_como_img6'},
    ];

    return (
        <ImagesSection imageList={imageList}/>
    );
}

export default ItalyComoImagesSection;
